<!--Hard Coded to Check intia work-->
<!-- <VFA-list-page></VFA-list-page> -->
<vg-vgn-nav app-id="VFA" stickiness="true">
  <router-outlet></router-outlet>
  <c11n-modal-dialog-entrypoint></c11n-modal-dialog-entrypoint>
</vg-vgn-nav>
